import {FACTIONS} from "../constants/factions";
import {FACTION_UNIT_SKINS} from "../constants/factionUnitsSkins";

export const FACTION_UNIT_SKIN_CONFIGS = [{
  id: FACTION_UNIT_SKINS.HUMANS,
  factionId: FACTIONS.HUMANS,
  priceNumens: 50000,
}, {
  id: FACTION_UNIT_SKINS.ORCS,
  factionId: FACTIONS.ORCS,
  priceNumens: 40000,
}, {
  id: FACTION_UNIT_SKINS.DWARVES,
  factionId: FACTIONS.DWARVES,
  priceNumens: 40000,
}, {
  id: FACTION_UNIT_SKINS.VENTORY,
  factionId: FACTIONS.VENTORY,
  priceNumens: 45000,
}, {
  id: FACTION_UNIT_SKINS.LEPRECHAUNS,
  factionId: FACTIONS.LEPRECHAUNS,
  priceNumens: 50000,
}, {
  id: FACTION_UNIT_SKINS.DEMONS,
  factionId: FACTIONS.DEMONS,
  priceNumens: 60000,
}, {
  id: FACTION_UNIT_SKINS.AQUARS,
  factionId: FACTIONS.AQUARS,
  priceNumens: 60000,
}, {
  id: FACTION_UNIT_SKINS.BEASTMEN,
  factionId: FACTIONS.BEASTMEN,
  priceNumens: 50000,
}, {
  id: FACTION_UNIT_SKINS.CELECTIALS,
  factionId: FACTIONS.CELECTIALS,
  priceNumens: 80000,
}, {
  id: FACTION_UNIT_SKINS.DARK_ELVES,
  factionId: FACTIONS.DARK_ELVES,
  priceNumens: 60000,
}, {
  id: FACTION_UNIT_SKINS.DOPPLERS,
  factionId: FACTIONS.DOPPLERS,
  priceNumens: 70000,
}, {
  id: FACTION_UNIT_SKINS.DRAGONS,
  factionId: FACTIONS.DRAGONS,
  priceNumens: 100000,
}, {
  id: FACTION_UNIT_SKINS.ELEMENTALS,
  factionId: FACTIONS.ELEMENTALS,
  priceNumens: 55000,
}, {
  id: FACTION_UNIT_SKINS.ELVES,
  factionId: FACTIONS.ELVES,
  priceNumens: 70000,
}, {
  id: FACTION_UNIT_SKINS.ENLIGHTENED,
  factionId: FACTIONS.ENLIGHTENED,
  priceNumens: 60000,
}, {
  id: FACTION_UNIT_SKINS.ENTS,
  factionId: FACTIONS.ENTS,
  priceNumens: 50000,
}, {
  id: FACTION_UNIT_SKINS.FENIX,
  factionId: FACTIONS.FENIX,
  priceNumens: 100000,
}, {
  id: FACTION_UNIT_SKINS.GIANTS,
  factionId: FACTIONS.GIANTS,
  priceNumens: 100000,
}, {
  id: FACTION_UNIT_SKINS.GOBLINS,
  factionId: FACTIONS.GOBLINS,
  priceNumens: 30000,
}, {
  id: FACTION_UNIT_SKINS.GREMLINS,
  factionId: FACTIONS.GREMLINS,
  priceNumens: 60000,
}, {
  id: FACTION_UNIT_SKINS.INSECTOIDS,
  factionId: FACTIONS.INSECTOIDS,
  priceNumens: 50000,
}, {
  id: FACTION_UNIT_SKINS.MUSHROOM_PEOPLE,
  factionId: FACTIONS.MUSHROOM_PEOPLE,
  priceNumens: 70000,
}, {
  id: FACTION_UNIT_SKINS.RATMEN,
  factionId: FACTIONS.RATMEN,
  priceNumens: 60000,
}, {
  id: FACTION_UNIT_SKINS.SPIRITS,
  factionId: FACTIONS.SPIRITS,
  priceNumens: 80000,
}, {
  id: FACTION_UNIT_SKINS.SUCCUBES,
  factionId: FACTIONS.SUCCUBES,
  priceNumens: 70000,
}, {
  id: FACTION_UNIT_SKINS.TECHNODWARVES,
  factionId: FACTIONS.TECHNODWARVES,
  priceNumens: 80000,
}, {
  id: FACTION_UNIT_SKINS.UNDEAD,
  factionId: FACTIONS.UNDEAD,
  priceNumens: 100000,
}, {
  id: FACTION_UNIT_SKINS.WIZARDS,
  factionId: FACTIONS.WIZARDS,
  priceNumens: 100000,
}]

export const FACTION_CONFIGS_IMPLEMENTED = FACTION_UNIT_SKIN_CONFIGS.filter(config => config.implemented);

export const FACTION_IDS_IMPLEMENTED = FACTION_CONFIGS_IMPLEMENTED.map(config => config.id);